// Module includes
import service from './service';

export default  angular.module('app.main.panel.module.userCode', [])
    .service("UserCodeModalService", service)
    .name;




/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/userCode/index.js
 **/